"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var localforage = require("localforage");
function getData(defaultData) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var data;
        var _this = this;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    data = tslib_1.__assign({}, defaultData);
                    return [4 /*yield*/, Promise.all(Object.keys(defaultData).map(function (key) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var value;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, localforage.getItem(key)];
                                    case 1:
                                        value = _a.sent();
                                        if (value !== null) {
                                            data[key] = value;
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/, data];
            }
        });
    });
}
exports.getData = getData;
function saveData(data) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _this = this;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(Object.keys(data).map(function (key) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, localforage.setItem(key, data[key])];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.saveData = saveData;
function removeItem(key) {
    return localforage.removeItem(key);
}
exports.removeItem = removeItem;
var clearData = localforage.clear;
exports.clearData = clearData;
